module.exports = __webpack_public_path__ + "media/process/Process1-bb39b493.png";